import { HttpClient } from '@angular/common/http';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
  isError: boolean = false

  constructor(private http: HttpClient, private notifier: NotificationsService) {
  }

  getTranslation(langCountry: string): Observable<any> {
    return new Observable((observer) => {
      this.http.get(`assets/i18n/${langCountry}.json?v=${environment.version}`).toPromise().then(data => {
        observer.next(data)
      }).catch((e) => {
        observer.next({})
        console.error(e)
        if (!this.isError) {
          this.isError = true
          this.notifier.error("Cannot load translations", "There is a problem with translations. Please try to refresh the page.", { timeOut: 8000 });
        }
      });
    })
  }
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {

  handle(params: MissingTranslationHandlerParams) {
    if (!environment.production)
      console.warn("MISSING TRANSLATION", params.key)
    return params.key;
  }
}

export const MissingTranlationConfig = {
  missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
  useDefaultLang: false
}
